import { combineReducers } from 'redux'
import { StateType as LocationState } from 'services/Location/reducer'
import { StateType as StoresState } from 'services/Stores/reducer'
import { StateType as RequestState } from 'services/Request/reducer'
import { StateType as LocalisationState } from 'services/Localisation/reducer'
import { StateType as StatesState } from 'services/States/reducer'
import { State as FeatureFlagsState } from 'services/FeatureFlags/reducer'

import * as servicesReducers from 'services/reducers'

export type AppState = {
  featureFlags: FeatureFlagsState
  location: LocationState
  stores: StoresState
  request: RequestState
  localisation: LocalisationState
  states: StatesState
  cms: any
}

const reducers = combineReducers({
  location: servicesReducers.locationReducer,
  stores: servicesReducers.storesReducer,
  request: servicesReducers.requestReducer,
  localisation: servicesReducers.localisationReducer,
  states: servicesReducers.statesReducer,
  cms: servicesReducers.cmsReducer,
  featureFlags: servicesReducers.featureFlagsReducer,
})

export default reducers
